// PrivacyPolicy.jsx
import React from "react";

const PrivacyPolicy = () => {
  return (
    <div className="pt-20 bg-gray-100">
      <div className="container mx-auto px-4 py-10">
        <div className="max-w-3xl mx-auto bg-white rounded-lg shadow-sm p-6 md:p-10">
          <h1 className="text-2xl font-bold text-gray-900 mb-6">
            プライバシーポリシー
          </h1>

          <p className="text-gray-700 leading-relaxed mb-6">
            本ページは「南富良野支援ナビ」（以下、本サイト）における、個人情報およびアクセス解析に関する取扱いを定めるものです。
          </p>

          <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-3">
            1 収集する情報
          </h2>
          <p className="text-gray-700 leading-relaxed mb-4">
            本サイトでは、利用状況の把握と改善のため、Google アナリティクス 4（GA4）を利用しています。GA4 により、Cookie 等を用いて、アクセス情報（閲覧ページ、滞在時間、参照元、端末情報等）が収集される場合があります。
          </p>

          <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-3">
            2 利用目的
          </h2>
          <p className="text-gray-700 leading-relaxed mb-4">
            収集したアクセス情報は、本サイトの利便性向上、内容改善、利用状況の分析にのみ利用します。
          </p>

          <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-3">
            3 第三者提供と外部送信
          </h2>
          <p className="text-gray-700 leading-relaxed mb-4">
            GA4 の仕組みにより、アクセス情報は Google LLC 等の外部事業者へ送信される場合があります。Google におけるデータの取扱いは、Google のポリシーに従います。
          </p>

          <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-3">
            4 Cookie の無効化
          </h2>
          <p className="text-gray-700 leading-relaxed mb-4">
            ブラウザ設定により Cookie を無効化することで、アクセス解析を制限できる場合があります。設定方法はご利用のブラウザの案内をご確認ください。
          </p>

          <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-3">
            5 お問い合わせ
          </h2>
          <p className="text-gray-700 leading-relaxed">
            本ポリシーに関するお問い合わせは、本サイトの「お問い合わせ」ページよりご連絡ください。
          </p>

        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
